import { useState } from 'react';
import * as Yup from 'yup';

export const useNoteForm = ({ note, onSuccess }) => {
  const [formKeyIndex, setFormKeyIndex] = useState(0);
  const formSchema = Yup.object().shape({
    title: Yup.string().nullable(),
    body: Yup.string().required('Note is a required field'),
  });
  const isCreateNote = !note || !note.id;
  const externalOptions = [
    {
      label: 'Only visible to your team',
      value: false,
    },
    {
      label: 'Visible to your team and on shared lists',
      value: true,
    },
  ];
  const initialValues = isCreateNote
    ? { title: '', external: externalOptions[0], body: '' }
    : { ...note, external: externalOptions.find((opt) => opt.value === note.external) };

  const onSubmit = (values) => {
    onSuccess(values, {
      resetForm: () => {
        setFormKeyIndex(formKeyIndex + 1);
      },
    });
  };

  return {
    formKeyIndex,
    formSchema,
    initialValues,
    externalOptions,
    isCreateNote,
    onSubmit,
  };
};
